<template>
    <BaseDialog v-model:open="open" :title="title" dialog-content-class="p-8 md:pb-8 flex flex-col gap-6 info-modal-content md:!max-w-2xl">
        <div class="flex flex-col gap-6">
            <!-- Icon + heading -->
            <div class="flex flex-col items-center gap-4 text-center">
                <span class="h-10 w-10 shrink-0 rounded-full bg-linear-to-br from-[#f5d6a1] to-[#f2c06e]"></span>
                <BaseHeader size="m" usage="nadia" class="text-valence-grey-850 text-pretty">{{ title }}</BaseHeader>
            </div>

            <!-- Sections -->
            <ul class="flex flex-col gap-4 text-center">
                <li v-for="section in sections" :key="section.title" class="flex flex-col items-center gap-1">
                    <div class="flex items-center gap-1.5">
                        <i class="shrink-0 text-base text-valence-primary-500" :class="`bi ${section.icon}`" aria-hidden="true"></i>
                        <p class="body-semibold text-valence-grey-850">{{ section.title }}</p>
                    </div>
                    <p class="body-small text-valence-grey-750">{{ section.description }}</p>
                </li>
            </ul>
        </div>

        <!-- CTA -->
        <BaseButton theme="primary" size="md" class="w-full" @click="open = false">Got it</BaseButton>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import BaseHeader from "~vue/components/BaseHeader.vue";

export interface InfoModalSection {
    icon: string;
    title: string;
    description: string;
}

defineProps<{
    title: string;
    sections: InfoModalSection[];
}>();

const open = defineModel<boolean>("open", { default: false });
</script>

<style scoped>
@keyframes modalEnter {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes modalLeave {
    from {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
    to {
        opacity: 0;
        transform: translateY(12px) scale(0.97);
    }
}

:global(.info-modal-content[data-state="open"]) {
    animation: modalEnter 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

:global(.info-modal-content[data-state="closed"]) {
    animation: modalLeave 0.2s ease both;
}
</style>
